module.exports = __webpack_public_path__ + "media/icons/okres-waznosci-dcacfb05.png";